module.exports = __webpack_public_path__ + "img/p5.13f91df4.png";